import { readSessionStoredValue, removeSessionStoredValue, writeSessionStoredValue } from './storage';

const planImportSessionKey = 'plan-import-draft';
const legacyTaskImportSessionKey = 'task-import-draft';

export type PlanImportDraft = {
  fileName: string;
  content: string;
  createdAt: number;
  source: 'plans-list-dnd';
};

type LegacyTaskImportDraft = Omit<PlanImportDraft, 'source'> & { source: 'tasks-list-dnd' };

const isPlanImportDraft = (value: unknown): value is PlanImportDraft | LegacyTaskImportDraft => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.fileName === 'string' &&
    typeof candidate.content === 'string' &&
    typeof candidate.createdAt === 'number' &&
    (candidate.source === 'plans-list-dnd' || candidate.source === 'tasks-list-dnd')
  );
};

export const savePlanImportDraft = (draft: PlanImportDraft): boolean => {
  try {
    return writeSessionStoredValue(planImportSessionKey, JSON.stringify(draft));
  } catch {
    return false;
  }
};

const readRawDraft = (key: string) => {
  try {
    // 저장소 차단 환경에서는 초안 없음으로 취급한다 (WEB-R).
    const raw = readSessionStoredValue(key);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw) as unknown;
    if (!isPlanImportDraft(parsed)) {
      return null;
    }

    return parsed;
  } catch {
    return null;
  }
};

export const readPlanImportDraft = (): PlanImportDraft | null => {
  const current = readRawDraft(planImportSessionKey);
  if (current && current.source === 'plans-list-dnd') {
    return current;
  }

  const legacy = readRawDraft(legacyTaskImportSessionKey);
  if (legacy) {
    return {
      fileName: legacy.fileName,
      content: legacy.content,
      createdAt: legacy.createdAt,
      source: 'plans-list-dnd',
    };
  }

  return null;
};

export const clearPlanImportDraft = (): void => {
  removeSessionStoredValue(planImportSessionKey);
  removeSessionStoredValue(legacyTaskImportSessionKey);
};
